import React from 'react'
import PaymentsPageLayout from 'container/PaymentsPageLayout'

const Payments: React.FC = () => {
	return <PaymentsPageLayout />
}

export default Payments
